import { AppPageRoutesWithTelemetry } from '@ms/yammer-page-route-telemetry';
import React, { FC } from 'react';

import { pageRoutes } from './loadablePageRoutes';

const Routes: FC = () => <AppPageRoutesWithTelemetry routes={pageRoutes} />;

export default Routes;
